import IBuilding = ZoningAPI.IBuilding;
import IBuildingOverlay = ZoningAPI.IBuildingOverlay;
import IBuildingVariance = ZoningAPI.IBuildingVariance;
import IBuildingEnvelope = ZoningAPI.IBuildingEnvelope;
import IBuildingZoningAllowance = ZoningAPI.IBuildingZoningAllowance;
import ICalculationNotification = ZoningAPI.ICalculationNotification;
import IBuildingFrontage = ZoningAPI.IBuildingFrontage;
import { ClonableItem } from './clonable-item';
import { CalculationNotification } from './calculation-notificarion';
import { BuildingOverlay } from './building-overlay';
import { BuildingFrontage } from './building-frontage';
import { UsesTypeName } from '../enums';
import * as _ from 'lodash';
import { ZoneCombination } from './zone-combination';
import { IBuildingModel } from '../interfaces/building-model.interface';
import { IBuildingCalibrationModel } from '../interfaces/building-calibration-model';
import { BuildingUse, IBuildingUsesModel } from './building-use';

export class Building extends ClonableItem<IBuilding> implements IBuildingModel {
    Id: number;
    ZonarId: number;
    Views: Object;
    LotType: number;

    Overlays: BuildingOverlay[];
    Variances: IBuildingVariance[];
    Uses: IBuildingUsesModel[];
    Envelope: IBuildingEnvelope;
    ZoningAllowance: IBuildingZoningAllowance;
    Calibration: IBuildingCalibrationModel;
    Notifications: ICalculationNotification[];
    Frontages?: IBuildingFrontage[];
    ApplicableTypologies?: IBuildingOverlay[];

    constructor(value?: IBuilding) {
        super(value);
        this.initNotifications();
        this.initOverlays();
        this.initFrontages();
        this.initUses();
        this.sortUsesByUsesTypeName();
        this.initApplicableTypologies();
        this.initZoneCombination();
    }

    private initNotifications() {
        this.initInstancesCollection('Notifications', CalculationNotification);
    }

    private initOverlays() {
        this.initInstancesCollection('Overlays', BuildingOverlay);
    }

    private initFrontages() {
        this.initInstancesCollection('Frontages', BuildingFrontage);
    }

    private initUses() {
        this.initInstancesCollection('Uses', BuildingUse);
    }

    private sortUsesByUsesTypeName() {
        this.Uses.sort((previousElement, nextElement) => {
            const indexOfPreviousElement = UsesTypeName[previousElement.TypeName];
            const indexOfNextElement = UsesTypeName[nextElement.TypeName];

            return indexOfPreviousElement > indexOfNextElement
                ? 1
                : indexOfPreviousElement === indexOfNextElement
                ? 0
                : -1;
        });
    }

    private initApplicableTypologies() {
        this.initInstancesCollection('ApplicableTypologies', BuildingOverlay);
    }

    private initZoneCombination() {
        if (!_.get(this, 'Calibration.ZoneCombination')) {
            return;
        }
        this.Calibration.ZoneCombination = new ZoneCombination(this.Calibration.ZoneCombination);
    }
}
